import * as actions from './actions'
import * as getters from './getters'

import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_ERROR,
  AUTH_LOGOUT,
  USER_SUCCESS,
  USER_ERROR,
  RESET_AUTH
} from './mutation-types'

function initialState () {
  return { 
    user: false,
    token: localStorage.getItem('token') || false,
    status: '',
    hasLoadedOnce: false
  }
}

// const initialState = {
//   user: false,
//   token: localStorage.getItem('token') || false,
//   status: '',
//   hasLoadedOnce: false
// }

const mutations = {

  [AUTH_REQUEST]: state => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, token) => {
    state.status = 'success'
    state.token = token
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: state => {
    localStorage.removeItem('token')
    state.token = false
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: state => {
    localStorage.removeItem('token')
	state = Object.assign(state, JSON.parse(JSON.stringify(initialState)))
  },
  [USER_SUCCESS]: (state, resp) => {
    state.user = resp.data
    state.status = 'success'
  },
  [USER_ERROR]: (state, resp) => {
    state.user = {}
    state.status = 'success'
  },
  [RESET_AUTH]: (state) => {
    localStorage.removeItem('token')
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  // state: { ...initialState },
  state: initialState,
  actions,
  getters,
  mutations
}
